// src/AssignRolesPage.js
import React, { useState } from "react";
import { Helmet } from "react-helmet";

function AssignRolesPage({ contract, signerContract }) {
  const [adminAddress, setAdminAddress] = useState("");
  const [creatorAddress, setCreatorAddress] = useState("");
  const [message, setMessage] = useState("");
  const [log, setLog] = useState([]);

  const handleAction = async (action, address) => {
    try {
      const tx = await signerContract[action](address);
      await tx.wait();
      const newLog = {
        action,
        address,
        timestamp: new Date().toLocaleString(),
        status: "success",
      };
      setLog([newLog, ...log.slice(0, 4)]); // Keep only last 5 logs
      setMessage(`${action} executed successfully!`);
    } catch (error) {
      console.error(`Error executing ${action}:`, error);
      const newLog = {
        action,
        address,
        timestamp: new Date().toLocaleString(),
        status: "fail",
      };
      setLog([newLog, ...log.slice(0, 4)]);
      setMessage(`Failed to execute ${action}.`);
    }
  };

  return (
    <div className="container mt-5">
      <Helmet>
        <title>6Degree - Assign Roles to Participants in Your Blockchain Event</title>
        <meta name="description" content="Easily assign roles to participants in your 6Degree blockchain event. Manage permissions and ensure fair participation." />
      </Helmet>
      <div className="text-center mb-4">
        <h1>Assign/Revoke Roles</h1>
      </div>

      <div className="mb-3">
        <h3>Add Admin</h3>
        <input
          type="text"
          className="form-control"
          placeholder="Admin Address"
          value={adminAddress}
          onChange={(e) => setAdminAddress(e.target.value)}
        />
        <button
          onClick={() => handleAction("addAdmin", adminAddress)}
          className="btn btn-success mt-2"
        >
          Add Admin
        </button>
      </div>

      <div className="mb-3">
        <h3>Remove Admin</h3>
        <input
          type="text"
          className="form-control"
          placeholder="Admin Address"
          value={adminAddress}
          onChange={(e) => setAdminAddress(e.target.value)}
        />
        <button
          onClick={() => handleAction("removeAdmin", adminAddress)}
          className="btn btn-danger mt-2"
        >
          Remove Admin
        </button>
      </div>

      <div className="mb-3">
        <h3>Add Creator</h3>
        <input
          type="text"
          className="form-control"
          placeholder="Creator Address"
          value={creatorAddress}
          onChange={(e) => setCreatorAddress(e.target.value)}
        />
        <button
          onClick={() => handleAction("addCreator", creatorAddress)}
          className="btn btn-success mt-2"
        >
          Add Creator
        </button>
      </div>

      <div className="mb-3">
        <h3>Remove Creator</h3>
        <input
          type="text"
          className="form-control"
          placeholder="Creator Address"
          value={creatorAddress}
          onChange={(e) => setCreatorAddress(e.target.value)}
        />
        <button
          onClick={() => handleAction("removeCreator", creatorAddress)}
          className="btn btn-danger mt-2"
        >
          Remove Creator
        </button>
      </div>

      {message && <div className="alert alert-info mt-4">{message}</div>}

      <div className="mt-5">
        <h4>Log</h4>
        <ul>
          {log.map((entry, index) => (
            <li key={index} style={{ color: entry.status === "fail" ? "red" : "black" }}>
              [{entry.timestamp}] {entry.action} - {entry.address} - {entry.status}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default AssignRolesPage;
